import { Component } from 'react'
import styles from '~/styles/ordersPage.timezones.module.css'
import types from '~/types/ordersPage.ts'

export default class Timezones extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'common' ],
		}
	}
	
	public constructor(props) {
		super(props)
		this.name = this.props.name || 'timezones'
		this._timezones = {}
		this._timezoneObject = {}
		this._getTimezones()
		const defaultTzName = Intl.DateTimeFormat().resolvedOptions().timeZone || ''
		const offset = (new Date().getTimezoneOffset() || 0) / 60 * -1
		const browserUtc = 'UTC' + (offset >= 0 ? '+' : '-') + offset
		this.defaultState = {
			type: 'types',
			timeZoneViewpoint: 'UserTzType',
			utc: 0,
			tzName: null,
		}
		const state = this._getFromLocalStorage() || this.defaultState
		state.defaultTzName = defaultTzName
		state.browserUtc = browserUtc
		this.state = state
		if (this.props.onTimezonesUpdate) {
			this.props.onTimezonesUpdate(this._onTimezonesUpdate.bind(this))
		}

		if (!this.props.currentTimezone) {
			const { tzCode, tzShownName } = this._getCurrentTimeZone()
			if (this.props.setTimezoneCode) {
				this.props.setTimezoneCode(tzCode)
				this.props.setTimezoneName(tzShownName)
			}
		}
	}
	
	public render(): JSX.Element {
		if (this.props.toShow === 'picker') {
			return (
				<TimezonePicker
					type={this.state.type}
					timeZoneViewpoint={this.state.timeZoneViewpoint}
					utc={this.state.utc}
					tzName={this.state.tzName}
					defaultTzName={this.state.defaultTzName}
					browserUtc={this.state.browserUtc}
					changeState={this._onChangeState.bind(this)}
					timezoneObject={this._timezoneObject}
					clickLabel={this.props.clickLabel}
					isRegionsShown={this.props.isRegionsShown}
					t={this.props.t}
				/>
			)
		} if (this.props.toShow === 'display') {
			return (
				<TimezoneDisplay
					timezoneName={this.props.timezoneName}
					t={this.props.t}
				/>
			)
		} else {
			return null
		}
	}

	private _onChangeState(key, value) {
		this.setState({ [key]: value })
		setTimeout(() => {
			const data = {
				type: this.state.type,
				timeZoneViewpoint: this.state.timeZoneViewpoint,
				utc: this.state.utc,
				tzName: this.state.tzName,
			}
			if (this.props.onTimezoneUpdate) {
				this.props.onTimezoneUpdate(data)
			}
			const { tzCode, tzShownName } = this._getCurrentTimeZone()
			if (!this.props.onTimezonesToInitials) {
				if (tzCode !== this.props.timezoneCode) {
					if (this._onChangeStateTO) {
						clearTimeout(this._onChangeStateTO)
					}
					this._onChangeStateTO = setTimeout(() => {
						if (typeof this.props.setOrderListUpdater === 'function') {
							this.props.onAction.send({
					            action: 'Timezone change',
					            actionData: {
					              file: 'components/OrdersPage/Timezones.tsx',
					              tzCode,
					              tzShownName,
					            },
					        })
							this.props.setOrderListUpdater(Date.now())
						}
					}, 1000)
				}
			}
			if (this.props.setTimezoneCode) {
				this.props.setTimezoneCode(tzCode)
				this.props.setTimezoneName(tzShownName)
			}
		})
	}

	private _getCurrentTimeZone() {
		let tzShownName
		let tzCode
		if (this.state.type === 'types') {
			tzShownName = this.state.timeZoneViewpoint
			tzCode = 'currentClient'
			if (this.state.timeZoneViewpoint === 'ClientFromOrderTzType') {
				tzCode = 'clientFromOrder'
			} else if (this.state.timeZoneViewpoint === 'CustomerTzType') {
				tzCode = 'customer'
			} else if (this.state.timeZoneViewpoint === 'UserTzType') {
				const offset = (new Date().getTimezoneOffset() || 0) / 60 * -1
				tzCode = offset
				tzShownName = 'UTC' + (offset >= 0 ? '+' : '-') + offset
			}
		} else if (this.state.type === 'utc') {
			tzShownName = 'UTC' + (this.state.utc >= 0 ? '+' : '-') + this.state.utc
			tzCode = this.state.utc
		} else if (this.state.type === 'name') {
			const defaultTzName = Intl.DateTimeFormat().resolvedOptions().timeZone || ''
			tzShownName = this.state.tzName || defaultTzName
			tzCode = this._timezones[tzShownName]
		}
		return { tzCode, tzShownName }
	}

	private _getFromLocalStorage() {
		const data = this._localStorage()
		if (typeof data === 'object') {
			return data
		}
	}

	private _localStorage(value) {
		try {
			if (typeof window !== 'undefined') {
				if (value) {
					window.localStorage.setItem(this.name, JSON.stringify(value))
				} else {
					return JSON.parse(window.localStorage.getItem(this.name))
				}
				
			}
		} catch(e) {}
	}

	private _getTimezones() {
		try {
			const timezones = Intl.supportedValuesOf('timeZone')
			if (timezones) {
				timezones.forEach(timezone => {
					const path = timezone.split('/')
					const value = this._getTimezoneByPath(timezone)
					if (path[0] !== 'Arctic' && path[0] !== 'Antarctica' && path[0] !== 'UTC') {
						if (!this._timezoneObject[path[0]]) {
							this._timezoneObject[path[0]] = {}
						}
						if (path[1]) {
							if (!this._timezoneObject[path[0]][path[1]]) {
								this._timezoneObject[path[0]][path[1]] = {}
							}
							if (!path[2]) {
								this._timezoneObject[path[0]][path[1]] = value
							}
						}
						if (path[2]) {
							if (!this._timezoneObject[path[0]][path[1]][path[2]]) {
								this._timezoneObject[path[0]][path[1]][path[2]] = {}
							}
							if (!path[3]) {
								this._timezoneObject[path[0]][path[1]][path[2]] = value
							}
						}
						this._timezones[timezone] = value
					}
				})
			}
		} catch(e) {}
	}

	private _getTimezoneByPath(timeZone) {
		const date = new Date()
		const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }))
  		const tzDate = new Date(date.toLocaleString('en-US', { timeZone }))
  		const offset = (tzDate.getTime() - utcDate.getTime()) / (1000 * 60 * 60) 
  		return offset
	}

	private _onTimezonesUpdate(save) {
		if (save) {
			const data = {
				type: this.state.type,
				timeZoneViewpoint: this.state.timeZoneViewpoint,
				utc: this.state.utc,
				tzName: this.state.tzName,
			}
			this._localStorage(data)
		} else {
			const state = this._getFromLocalStorage() || this.defaultState
			this.setState(state)
		}
	}
}

class TimezoneDisplay extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders' ],
		}
	}

	public constructor(props) {
		super(props)
	}
	
	public render(): JSX.Element {
		return (
			<div
				className={styles.timezoneDisplay}
			>
				<div>
					<label>
						{this.props.t('common:Time zone')}
					</label>
					<div>
						{this.props.t('common:' + this.props.timezoneName)}
					</div>
				</div>
			</div>
		)
	}
}


class TimezonePicker extends Component {
	static getInitialProps() {
		return {
			namespacesRequired: [ 'Orders' ],
		}
	}

	public constructor(props) {
		super(props)
		this.state = {
			areNameZonesClosed: true,
		}
		this._clickLabelTimezones = this.props.clickLabel + 'Timezones'
		this._clickLabelAntiTimezones = this.props.clickLabel + 'AntiTimezones'
		this._clickLabelTimezoneName = this.props.clickLabel + 'TimezoneName'
	}
	
	public render(): JSX.Element {
		let tzClickLabel = this._clickLabelTimezones
		if (this.props.clickLabel === this._clickLabelTimezones) {
			tzClickLabel = this._clickLabelAntiTimezones
		}
		return (
			<div
				className={styles.timezonePicker}
				onClick={this._onClick.bind(this)}
			>
				<label>
					{this.props.t('Time zone')}
				</label>
				<div>
					<div
						className={styles.typesFrame}
					>
						<input
							type='radio'
							checked={this.props.type === 'types'}
							onChange={() => {}}
						/>
						<div>
							<select
								value={this.props.timeZoneViewpoint}
								onChange={this._onTimeZoneViewpoint.bind(this)}
							>
								<option
									value='CurrentClientTzType'
								>
									{this.props.t('common:CurrentClientTzType')}
								</option>
								<option
									value='ClientFromOrderTzType'
								>
									{this.props.t('common:ClientFromOrderTzType')}
								</option>
								<option
									value='CustomerTzType'
								>
									{this.props.t('common:CustomerTzType')}
								</option>
								<option
									value='UserTzType'
								>
									{this.props.t('common:UserTzType') + ' (' + this.props.browserUtc + ')'}
								</option>
							</select>
						</div>
					</div>
					<div
						className={styles.utcFrame}
					>
						<input
							type='radio'
							checked={this.props.type === 'utc'}
							onChange={() => {}}
						/>
						<div
							className={styles.label}
						>
							UTC
						</div>
						<input
							type='number'
							min="-11"
							max="14"
							step="1"
							value={this.props.utc}
							onChange={this._onUtc.bind(this)}
						/>
					</div>
					<div
						className={this.props.isRegionsShown ? styles.nameFrame : styles.hidden}
					>
						<input
							type='radio'
							checked={this.props.type === 'name'}
							onChange={() => {}}
						/>
						<div
							className={styles.label}
						>
							{this.props.t('common:TzName')}
						</div>
						<div
							className={styles.tzName}
							clicklabel={tzClickLabel}
						>
							<div>
								{this.props.tzName || this.props.defaultTzName}
							</div>
							{this._getZonesFrame()}
						</div>
					</div>
				</div>
			</div>
		)
	}

	private _getZonesFrame() {
		if (this.props.clickLabel === this._clickLabelTimezones) {
			return (
				<div
					className={styles.zones}
					clicklabel={this._clickLabelTimezones}
				>
					{this._getZones()}
				</div>
			)
		} else {
			return null
		}
	}

	private _getZones(object, path) {
		let jsx = []
		let isFirst = false
		if (!object) {
			isFirst = true
			object = this.props.timezoneObject
		}
		Object.keys(object || {}).forEach(key => {
			const previousPath = (path ? path + '/' : '')
			const currentPath = previousPath + key
			const subJsx = this._getZones(object[key] || {}, currentPath)
			let rowClass = styles.tzRow
			const isClickedSub = (this.state.zoneOpenedPath + '/' === previousPath)
			const isClickedPrevious = ((this.state.zoneOpenedPath + '/').includes(previousPath))
			const isClickedSuper = previousPath && isClickedPrevious
			if (!isFirst && !isClickedSub && !isClickedSuper) {
				rowClass += ' ' + styles.tzRowClosed
			}
			let label = key
			if (subJsx?.length) {
				label = (
					<div
						onClick={this._onZoneOpen.bind(this, currentPath)}
					>
						<div>
							{'\u203A'}
						</div>
						<div>
							{key}
						</div>
					</div>
				)
				rowClass += ' ' + styles.tzRowMulti
			} else {
				label = (
					<div
						onClick={this._onZonePicked.bind(this, currentPath)}
						clickLabel={this._clickLabelTimezoneName}
					>
						{key}
					</div>
				)
			}
			jsx.push((
				<div
					className={rowClass}
				>
					<div>
						{label}
					</div>
					<div>
						{subJsx}
					</div>
				</div>
			))
		})
		return jsx
	}

	private _onClick(event): void {
		const target = event.target
		let tzType = null
		if (target.closest('div[class*="typesFrame"]')) {
			tzType = 'types'
		} else if (target.closest('div[class*="utcFrame"]')) {
			tzType = 'utc'
		} else if (target.closest('div[class*="nameFrame"]')) {
			tzType = 'name'
		}
		if (tzType) {
			this.props.changeState('type', tzType)
		}
	}

	private _onZoneOpen(path) {
		if (this.state.zoneOpenedPath === path) {
			this.setState({ zoneOpenedPath: null })	
		} else {
			this.setState({ zoneOpenedPath: path })
		}
	}

	private _onZonePicked(path) {
		this.props.changeState('tzName', path)
	}

	private _onTimeZoneViewpoint(event): void {
		let value = event.target.value
		if (this._onTimeZoneViewST) {
			clearTimeout(this._onTimeZoneViewST)
		}
		this._onTimeZoneViewST = setTimeout(() => {
			this.props.changeState('timeZoneViewpoint', value)
			clearTimeout(this._onTimeZoneViewST)
		})
	}

	private _onUtc(event): void {
		let value = event.target.value
		if (+value >= -11 && +value <= 14) { 
			this.props.changeState('utc', +value)
		}
	}
}